module.exports = __webpack_public_path__ + "static/img/case_jianzhijia.33d1d05e.png";